// extracted by mini-css-extract-plugin
module.exports = {"header":"e_D1","gallery":"e_E1","label":"e_F1"};